import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { configureNativeRuntime } from "@/native/runtime";
import { cleanupExportCache } from "@/native/files";

let startupFailed = false;
try {
  configureNativeRuntime();
} catch {
  startupFailed = true;
}

// Run outside StrictMode so mounting the app cannot duplicate startup cleanup.
void cleanupExportCache().catch((error) => {
  console.warn("Could not clean up old export files.", error);
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  startupFailed ? (
    <main role="alert" className="mx-auto max-w-lg p-6">
      <h1 className="text-xl font-semibold">Unable to start the app</h1>
      <p className="mt-3">
        The app&apos;s secure connection settings are invalid. Please contact your
        administrator or install the latest version.
      </p>
    </main>
  ) : (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>
  ),
);
